import { Stack, Typography } from "@mui/material";

interface InfoRowProps {
  label: string;
  value?: string | number | null;
  gap?: number;
}

export function InfoRow({
  label,
  value,
  gap = 15,
}: InfoRowProps) {
  return (
    <Stack direction="row"  alignContent={"flex-start"}alignItems={"flex-start"} >
      <Typography fontWeight={600} fontSize="1rem" width={260}>
        {label}
      </Typography>

      <Typography fontWeight={300} fontSize="1rem">
        {value ?? "-"}
      </Typography>
    </Stack>
  );
}
